<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('profilefile_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-file-cog-outline</v-icon>{{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-profilefile-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('global.name') }}</strong></td>
              <td>
                                    {{ item['name'] }}
              </td>
              <td><strong>{{ $t('global.namefr') }}</strong></td>
              <td>
                                    {{ item['namefr'] }}
              </td>
            </tr>
            <tr>

              <td><strong>{{ $t('global.file') }}</strong></td>
              <td>
                                    <v-btn
                                         v-if="item['file']"
                                         color="secondary"
                                         class=""
                                         @click="downloadFileByObject(item)"
                                       >
                                         {{ $t('global.download') }}
                                         <v-icon
                                           right
                                           dark
                                         >mdi-download
                                         </v-icon>
                                       </v-btn>
              </td>
              <td><strong>{{ $t('profile.version') }}</strong></td>
              <td>
                                    {{ item['version'] }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('profile.public') }}</strong></td>
              <td>
                <span v-if="item.public" class="mr-2"><v-icon color="green">mdi-check-circle</v-icon></span>
                <span v-else class="mr-2"><v-icon color="red">mdi-close-circle</v-icon></span>
              </td>
              <td><strong>{{ $t('profile.experimental') }}</strong></td>
              <td>
                <span v-if="item.experimental" class="mr-2"><span class="red--text">{{ $t('global.true') }}</span></span>
                <span v-else class="mr-2"><span class="green--text">{{ $t('global.false') }}</span></span>
              </td>
            </tr>
            <!--<tr>
              <td><strong>{{ $t('profile.newrelease') }}</strong></td>
              <td>
                <span v-if="item.newRelease" class="mr-2"><v-icon color="green">mdi-check-circle</v-icon></span>
                <span v-else class="mr-2"><v-icon color="red">mdi-close-circle</v-icon></span>
              </td>
              <td><strong>{{ $t('profile.updaterelease') }}</strong></td>
              <td>
                <span v-if="item.updateRelease" class="mr-2"><span class="red--text">{{ $t('global.true') }}</span></span>
                <span v-else class="mr-2"><span class="green--text">{{ $t('global.false') }}</span></span>
              </td>
            </tr>-->
            <tr>
              <td><strong>{{ $t('profile.material.types') }}</strong></td>
              <td>
                <span v-if="item['materialType']" >{{ item['materialType'].name }}</span>
              </td>
              <td><strong>{{ $t('profile.material.manufacturer') }}</strong></td>
              <td>
                <span v-if="item['materialManufacturer']" >{{ item['materialManufacturer'].name }}</span>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('profile.software.softwares') }}</strong></td>
              <td>
                <ul>
                  <li v-for="_item in item['softwares']" :key="_item.id">
                    {{ _item.name }}
                  </li>
                </ul>
              </td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td><strong>{{ $t('qualitycheck.product.machines') }}</strong></td>
              <td>
                <ul>
                  <li v-for="_item in item['machines']" :key="_item.id">
                    {{ _item.name }}
                  </li>
                </ul>
              </td>
              <td><strong>{{ $t('qualitycheck.product.toolheads') }}</strong></td>
              <td>
                <ul>
                  <li v-for="_item in item['toolheads']" :key="_item.id">
                    {{ _item.name }}
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('qualitycheck.product.options') }}</strong></td>
              <td>
                <ul>
                  <li v-for="_item in item['options']" :key="_item.id">
                    {{ _item.name }}
                  </li>
                </ul>
              </td>
              <td><strong>{{ $t('profile.printingsurface.printingsurfaces') }}</strong></td>
              <td>
                <ul>
                  <li v-for="_item in item['surfaces']" :key="_item.id">                    
                    <span  v-if="language == 'fr'" > {{ _item.namefr }}</span>
                    <span v-else > {{ _item.name }}</span>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('profile.material.colors') }}</strong></td>
              <td>
                <ul>
                  <li v-for="_item in item['colors']" :key="_item.id">
                    <span  v-if="language == 'fr'" > {{ _item.namefr }}</span>
                    <span v-else > {{ _item.name }}</span>
                  </li>
                </ul>
              </td>
              <td><strong>{{ $t('profile.quality.qualities') }}</strong></td>
              <td>
                <ul>
                  <li v-for="_item in item['qualities']" :key="_item.id">
                    <span  v-if="language == 'fr'" > {{ _item.namefr }}</span>
                    <span v-else > {{ _item.name }}</span>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('profile.nozzle.materials') }}</strong></td>
              <td>
                <ul>
                  <li v-for="_item in item['nozzleMaterials']" :key="_item.id">
                    <span  v-if="language == 'fr'" > {{ _item.namefr }}</span>
                    <span v-else > {{ _item.name }}</span>
                  </li>
                </ul>
              </td>
              <td><strong>{{ $t('profile.quality.nozzlesout') }}</strong></td>
              <td>
                <ul>
                  <li v-for="_item in item['nozzles']" :key="_item.id">
                    {{ _item.size }}
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('profile.quality.layers') }}</strong></td>
              <td>
                <ul>
                  <li v-for="_item in item['layers']" :key="_item.id">
                    {{ _item.height }}
                  </li>
                </ul>
              </td>
              <td></td>
              <td>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('profile.material.medium') }}</strong></td>
              <td>
                <span v-if="item['medium']" >{{ item['medium'].name }}</span>
              </td>
              <td><strong>{{ $t('profile.reference') }}</strong></td>
              <td>
                <span >{{ item['reference'] }}</span>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('profile.customersreserved') }}</strong></td>
              <td>
                <ul>
                  <li v-for="_item in item['customers']" :key="_item.id">
                    {{ _item.name }}
                  </li>
                </ul>
              </td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td><strong>{{ $t('global.created') }}</strong></td>
              <td>
                  {{ formatDateTime(item['created'], 'long') }}
              </td>
              <td><strong>{{ $t('global.createdby') }}</strong></td>
              <td>
                  <span v-if="item['createdBy']">{{ item['createdBy'].login }}</span>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('global.updated') }}</strong></td>
              <td>
                  {{ formatDateTime(item['updated'], 'long') }}
              </td>
              <td><strong>{{ $t('global.updatedby') }}</strong></td>
              <td>
                  <span v-if="item['updatedBy']">{{ item['updatedBy'].login }}</span>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('profile.description') }}</strong></td>
              <td colspan="3">
                <span >{{ item['description'] }}</span>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('profile.descriptionfr') }}</strong></td>
              <td colspan="3">
                <span >{{ item['descriptionfr'] }}</span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import i18n from '../../i18n.js';
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';
import FileMixin from '../../mixins/FileMixin';

const servicePrefix = 'ProfileFile';

export default {
  name: 'ProfileFileShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar,
  },
  data() {
    return {

    };
  },
  mixins: [ShowMixin,AccessMixin,FileMixin],
  computed: {
    ...mapFields('profilefile', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('profilefile', ['find']),
    language() {
      return i18n.locale;
    },

  },
  methods: {
    ...mapActions('profilefile', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    }),

  }
};
</script>
